<template>
  <div class="home">
    <div class="powr-hit-counter" id="2e30360a_1649863437"></div>
    <h1 id="title">Las Rutas de nandomoneda</h1>
    <img alt="nandomoneda" src="../assets/profile.jpg" width="200px">
    <div class="description">
      <p>Hace ya algunos años, llegó a mis manos un pequeño libro ("Xarxa catalana de senders i de rutes temàtiques").
      Este libro recorre todos los senderos (GR - PR - SL, Rutas Temáticas) hasta 2010. Al ojearlo me dije: ¿Y porqué no?
      <br>Este fue el inicio de este reto en el que, con el paso del tiempo, observé la dificultad que entrañaban algunos senderos
      (mal señalizados, obsoletos, o simplemente desparecidos).
      <br>La finalidad de esta web es recopilar todos los senderos que vaya encontrando para los que deseen realizarlos.
      Y de paso, que este sea un punto de encuentro para los que tengan pistas de los que puedan faltar...
      <br>Actualmente y después de pasar un tiempo caminando por otras rutas, añado dos pestañas más ("Otros PR" y "Otros GR") para ir ampliando la página inicial
      <br>SALUT I CAMES!</p>
    </div>
    <div id="search-bar">
      <div class="search-bar-container">
        <input class="search-bar-input"
        type="text" 
        placeholder="Busca tu ruta. Ejemplo: PR-C 11" 
        v-model="searchValue">
      </div>
    </div>
    <div id="tabs">
      <div class="tabs-container">
        <div v-for="(routeType, index) in routeTypes" 
        :key="routeType.name" 
        :class="`tab ${routeType.isActive?'active':''}`"
        v-on:click="selectTab(index)">{{routeType.display}}</div>
      </div>
    </div>
    <RoutesList :routes-list="this.filteredRoutes"></RoutesList>
  </div>
</template>

<script>
// @ is an alias to /src
import RoutesList from '@/components/RoutesList.vue';
import firebase from 'firebase/app';
import 'firebase/database'

export default {
  name: 'Home',
  components: {
    RoutesList
  },
  data: function() {
    return {
      routes: {"PR": [], "SL": [], "GR": [], "T": []},
      filteredRoutes: [],
      routeTypes: [
        {"name": "PR", "display": "PR", "isActive": true},
        {"name": "SL", "display": "SL", "isActive": false},
        {"name": "GR", "display": "GR", "isActive": false},
        {"name": "T", "display": "Temáticas", "isActive": false},
        //{"name": "OtherPR", "display": "Otros PR", "isActive": false},
        //{"name": "OtherSL", "display": "Otros SL", "isActive": false},
        {"name": "OtherGR", "display": "Otros GR", "isActive": false},
      ],
      activeTab: 'PR',
      searchValue: ''
    }
  },
  mounted: function() {
    let database = firebase.database();
    this.initRoutes(database, "PR");
    this.initRoutes(database, "SL");
    this.initRoutes(database, "GR");
    this.initRoutes(database, "T");
    this.initRoutes(database, "OtherPR");
    //this.initRoutes(database, "OtherSL");
    this.initRoutes(database, "OtherGR");
  },
  methods: {
    initRoutes(database, routeType) {
      console.log(`routes${routeType}`);
      database.ref(`routes${routeType}`).on('value', snapshot => {
        const data = snapshot.val();
        this.routes[routeType] = data?data:[];
      });

      database.ref(`routes${routeType}`).get()
      .then(snapshot => {
        const data = snapshot.val();
        this.routes[routeType] = data?data:[];
        if (routeType === "PR") {
          this.filteredRoutes = this.routes[routeType];
        }
      }).catch(err => {
        console.log(err);
        this.routes[routeType] = [];
      });
    },
    selectTab(index) {
      // Turn previos active tab to not active
      for (let i=0; i<this.routeTypes.length; i++) {
        if (this.routeTypes[i].isActive) {
          this.routeTypes[i].isActive = false;
          break;
        }
      }

      // Set new tab to active
      this.routeTypes[index].isActive = true;
      // Show list of routes from new tab
      this.activeTab = this.routeTypes[index].name;
      this.filteredRoutes = this.routes[this.activeTab];
      this.searchValue = '';
    }
  },
  watch: {
    searchValue: function (newSearchValue) {
      this.filteredRoutes = this.routes[this.activeTab].filter(
        route => (route.title.toLowerCase().indexOf(newSearchValue.toLowerCase()) !== -1 ||
                  (route.name && route.name.toLowerCase().indexOf(newSearchValue.toLowerCase()) !== -1)));
    }
  }
}
</script>

<style>
.home img {
  border-radius: 6px;
  margin-bottom: 20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

body {
  /* The image used */
  background: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ), url("../assets/background.jpg");

  /* Full height */
  height: 100%; 

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}

#title, .description{
  color: white
}

.description {
  justify-content: center;
  display: flex;
}

.description p{
  max-width: 50%;
  text-align: justify;
  font-size: 17px;
  font-weight: 500;
}

#tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

#search-bar {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.tabs-container, .search-bar-container {
  width: 50%;
}

.tab {
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid transparent;
  border-radius: 6px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  padding: 6px;
  text-align: left;
  display: inline-block;
  width: fit-content;
  font-size: 18px;
  font-weight: bold;
  margin-right: 5px;
  cursor: pointer;
}

.tab.active {
  background: white;
}

.search-bar-input {
  background: white;
  border: 1px solid transparent;
  border-radius: 6px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  padding: 6px;
  font-size: 18px;
  width: 100%;
}
</style>
